module.exports = __webpack_public_path__ + "images/emoji/sunrise.ef2e9c1947381fee1332.png";